import React, {useState, useContext} from 'react';
import {Stack, Button, Icon, Collapsible} from '@shopify/polaris';
import {ChevronRightMinor, ChevronDownMinor, ExternalSmallMinor} from '@shopify/polaris-icons';
import Content from './Content'
import EditContainer from './EditContainer'
import {CourseTreeContext} from '../contexts/CourseTree'

export default function Container(props) {
  const [courseTree, updateCourseTree, isOpen, toggleOpen] = useContext(CourseTreeContext)

  const {id, name, child_nodes, number} = props.item

  const open = isOpen(id)

  return (
    <div className="container">
      <Stack>
        <span className="openClose"><Button plain icon={<Icon source={isOpen(id) ? ChevronDownMinor : ChevronRightMinor} />} onClick={() => toggleOpen(id)}/></span>
        <EditContainer linkText={`${number} ${name}`} title={`Edit ${name}`} item={props.item}/>
      </Stack>
      <Collapsible
        open={open}
        id="basic-collapsible"
        transition={{duration: '500ms', timingFunction: 'ease-in-out'}}
        expandOnPrint
      >
        <div className="collapsible">
        {
          open ?
          (child_nodes || []).map((child_node) => {
            if (child_node.type == 'container') {
              return <Container item={child_node} key={child_node.id}/>
            } else if (child_node.type == 'content') {
              return <Content item={child_node} key={child_node.id}/>
            }
          }) : null
        }
        </div>
      </Collapsible>
    </div>
  )
}
